/** Общее для мини-игр «деньги» (E8–E10): совершеннолетие и чтение позиции из флагов. */
import type { Life } from '@life/engine';

export const ADULT_AGE = 18;

/** Числовой флаг жизни ≥ 0 (стоимость позиции, сумма займа); иначе 0. */
export function heldOf(life: Life, key: string): number {
  const raw = life.flags[key];
  return typeof raw === 'number' && Number.isFinite(raw) && raw > 0 ? raw : 0;
}
